import script from "./SailingsTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./SailingsTable.vue?vue&type=script&lang=ts&setup=true"

import "./SailingsTable.vue?vue&type=style&index=0&id=247e4f60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_3adea55ba6ae913f8a015974add4e384/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-247e4f60"]])

export default __exports__